import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  pdf,
  Document,
  Page,
  Text,
  View,
  Image,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import moment from "moment";
import { styles } from "./CertificatePDFStyle";
import ASC22 from "../../assets/images/ASC22.jpg";
import pdf_icon from "../../assets/icons/pdf_icon.svg";
import {
  filesInsertDocToS3,
  AdddocumenttoTask,
  FetchFormCertificate,
} from "../../redux/actions/action";

import axios from "axios";
import { API_URL } from "../../redux/constants/type";

const tableData = [
  { Fname: "Ankit", Mname: "Singh", Lname: "Chandel", Age: 26, City: "Delhi" },
  { Fname: "Ravi", Mname: "Kumar", Lname: "Yadav", Age: 28, City: "Mumbai" },
  { Fname: "Neha", Mname: "Raj", Lname: "Sharma", Age: 24, City: "Bangalore" },
  { Fname: "Priya", Mname: "Kumari", Lname: "Verma", Age: 25, City: "Kolkata" },
  { Fname: "Arjun", Mname: "Singh", Lname: "Thakur", Age: 29, City: "Jaipur" },
  { Fname: "Rahul", Mname: "Kumar", Lname: "Mehta", Age: 30, City: "Lucknow" },
  { Fname: "Sanya", Mname: "Rani", Lname: "Patel", Age: 27, City: "Pune" },
  {
    Fname: "Karan",
    Mname: "Dev",
    Lname: "Malhotra",
    Age: 32,
    City: "Ahmedabad",
  },
];

// PDF Document Component
const MyDocument = (props) => {
  console.log("asc23 pdfData", props);
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* 🔹 HEADER (Fixed on all pages) */}
        {/* <View style={styles.header} fixed>
          <Text style={styles.headerLeft}>Ankit</Text>
          <Text style={styles.headerCenter}>Singh</Text>
          <Text style={styles.headerCenter}>Chandel</Text>
          <Text style={styles.headerRight}>
            {moment().format("DD/MM/YYYY")}
          </Text>
        </View> */}

        {/* IMAGE */}
        {/* <Image style={styles.image} src={ASC22} /> */}

        {/* pdf border start */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          fixed
        >
          <Image
            style={styles.image5}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/leftLogo.png"
            }
          />

          <Image
            style={styles.image}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/mainlogo.png"
            }
          />

          <Image
            style={styles.image2}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/logo2.png"
            }
          />
        </View>
        {/* pdf border end */}

        <View style={styles.section}>
          <Text style={styles.text}>CERTIFICAAT</Text>
          <Text style={styles.text2}>JANSENVENTILATIE</Text>
        </View>

        <View style={styles.greenLine} />

        <View style={styles.flexDiv}>
          <View>
            <Text style={styles.flexTxt}>JansenVentilatie</Text>
            <Text style={styles.flexTxt2}>REINIGING ONDERHOUD REPARATIE</Text>

            <Text
              style={[
                styles.flexTxt,
                { paddingTop: "17px", fontSize: 10, letterSpacing: 0 },
              ]}
            >
              Wei Ming
            </Text>
            <Text style={[styles.flexTxt, { fontSize: 10, letterSpacing: 0 }]}>
              Het Ruim 23
            </Text>
            <Text style={[styles.flexTxt, { fontSize: 10, letterSpacing: 0 }]}>
              8251 EL Dronten
            </Text>
          </View>

          <View>
            <Text
              style={[
                styles.flexTxt,
                {
                  fontSize: 14,
                  letterSpacing: 0,
                  fontWeight: 900,
                  fontFamily: "Manrope",
                },
              ]}
            >
              Jansenventilatie
            </Text>
            <Text style={styles.flexTxt3}>Hoogeveenstraat 13</Text>

            <Text style={[styles.flexTxt3, { paddingTop: "2px" }]}>
              1324CN Almere
            </Text>
            <Text style={[styles.flexTxt3, { paddingTop: "2px" }]}>
              0851304654
            </Text>
            <Text style={[styles.flexTxt3, { paddingTop: "2px" }]}>
              KVK 88540723
            </Text>
          </View>
        </View>

        <Text
          style={{
            textAlign: "right",
            fontSize: 11,
            paddingTop: "12px",
            paddingRight: "25px",
            paddingBottom: "20px",
            letterSpacing: 0.5,
          }}
        >
          {`Datum: ${moment().format("DD–MM–YYYY")}`}
        </Text>

        <Text
          style={{
            fontSize: 11,
            paddingLeft: "10px",
            paddingRight: "30px",
            paddingBottom: "15px",
            letterSpacing: 0.5,
            lineHeight: 1.4,
          }}
        >
          Hierbij bevestigt Jansenventilatie dat wij op het bovenvermelde adres
          de afzuigkap, het vetkanaal en de motor van het afzuigsysteem hebben
          gereinigd.
        </Text>

        {/* DYNAMIC TABLE */}
        <View style={[styles.table, { display: "none" }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { justifyContent: "center" }]}>
              <Text style={styles.tableHeaderText}>CONTROLEPUNT</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderText}>VERVUILINGSGRAAD</Text>
              <Text style={styles.tableHeaderText}>VOOR REINING</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderText}>VERVUILINGSGRAAD</Text>
              <Text style={styles.tableHeaderText}>NA REINING</Text>
            </View>
          </View>

          {/* Dynamic Rows */}
          {props?.data?.formData?.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>{item.question}</Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>{"—"}</Text>
              </View>
              <View style={styles.tableCol2}>
                <Text style={styles.tableCell}>{item.answer}</Text>
              </View>
            </View>
          ))}
        </View>

        {/* DYNAMIC TABLE 2 */}
        {props?.data?.formData?.map((form, formIndex) => (
          <View
            key={formIndex}
            // marginBottom: 20, or marginVertical: 20
            style={{ marginTop: 5, marginBottom: 10 }}
          >
            {/* Form Name */}
            <Text style={styles.formName}>{form.formName}</Text>

            {/* Table Header */}
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={[styles.tableCol, { justifyContent: "center" }]}>
                  <Text style={styles.tableHeaderText}>CONTROLEPUNT</Text>
                </View>
                {/* <View style={styles.tableCol}>
                  <Text style={styles.tableHeaderText}>VERVUILINGSGRAAD</Text>
                  <Text style={styles.tableHeaderText}>VOOR REINING</Text>
                </View> */}
                {/* <View style={styles.tableCol}>
                  <Text style={styles.tableHeaderText}>VERVUILINGSGRAAD</Text>
                  <Text style={styles.tableHeaderText}>NA REINING</Text>
                </View> */}
                <View style={styles.tableCol}>
                  <Text style={styles.tableHeaderText}>
                    ANTWOORDEN BESMETTINGSNIVEAU
                  </Text>
                  {/* <Text style={styles.tableHeaderText}>NA REINING</Text> */}
                </View>
              </View>

              {/* Dynamic Form Data */}
              {form.formresponse.map((item, index) => (
                <View key={index} style={styles.tableRow}>
                  <View style={styles.tableCol2}>
                    <Text style={styles.tableCell}>{item.question}</Text>
                  </View>
                  {/* <View style={styles.tableCol2}>
                    <Text style={styles.tableCell}>{"—"}</Text>
                  </View> */}
                  <View style={styles.tableCol2}>
                    <Text style={styles.tableCell}>{item.answer || "—"}</Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        ))}

        <Text
          style={{
            fontSize: 11,
            paddingTop: "8px",
            paddingLeft: "5px",
            // paddingBottom: "20px",
            paddingBottom: "10px",
          }}
        >
          * Advies voor periodieke reiniging van het vetkanaal
        </Text>
      </Page>

      {/* <View style={{ marginVertical: 10 }} /> */}

      <Page size="A4" style={styles.page} wrap>
        {/* pdf border start */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          fixed
        >
          <Image
            style={styles.image5}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/leftLogo.png"
            }
          />

          <Image
            style={styles.image}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/mainlogo.png"
            }
          />

          <Image
            style={styles.image2}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/logo2.png"
            }
          />
        </View>
        {/* pdf border end */}

        <View
          style={{
            marginBottom: 20,
          }}
        >
          <Text
            style={{
              fontSize: 14,
              fontFamily: "Manrope",
              fontWeight: 900,
              paddingTop: "3px",
              paddingLeft: "5px",
              paddingBottom: "10px",
            }}
          >
            {/* pre imgs */}
            Situatie voor de reiniging
          </Text>

          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              // justifyContent: "space-between",
            }}
          >
            {props?.data?.document
              ?.filter((x) => x.isStarted === 1)
              .map((item, index) => (
                <Image
                  key={index}
                  src={item.url}
                  style={{
                    width: "32%",
                    objectFit: "cover",
                  }}
                />
              ))}
          </View>
        </View>
      </Page>

      {/* <View style={{ marginVertical: 10 }} /> */}

      <Page size="A4" style={styles.page} wrap>
        {/* pdf border start */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          fixed
        >
          <Image
            style={styles.image5}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/leftLogo.png"
            }
          />

          <Image
            style={styles.image}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/mainlogo.png"
            }
          />

          <Image
            style={styles.image2}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/logo2.png"
            }
          />
        </View>
        {/* pdf border end */}

        <View>
          <Text
            style={{
              fontSize: 14,
              fontFamily: "Manrope",
              fontWeight: 900,
              paddingTop: "3px",
              paddingLeft: "5px",
              paddingBottom: "10px",
            }}
          >
            {/* post imgs */}
            Situatie na de reiniging
          </Text>

          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 10,
              // justifyContent: "space-between",
            }}
          >
            {props?.data?.document
              ?.filter((x) => x.isStarted === 2)
              .map((item, index) => (
                <Image
                  key={index}
                  src={item.url}
                  style={{
                    width: "32%",
                    objectFit: "cover",
                  }}
                />
              ))}
          </View>
        </View>
      </Page>

      <Page size="A4" style={styles.page} wrap>
        {/* pdf border start */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          fixed
        >
          <Image
            style={styles.image5}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/leftLogo.png"
            }
          />

          <Image
            style={styles.image}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/mainlogo.png"
            }
          />

          <Image
            style={styles.image2}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/logo2.png"
            }
          />
        </View>
        {/* pdf border end */}

        <Text
          style={{
            fontSize: 12,
            fontFamily: "Manrope",
            fontWeight: 700,
            paddingLeft: "5px",
            marginTop: "50px",
            // paddingBottom: "8px",
          }}
        >
          {/* Uitvoerder: */}
          Signature performer:
        </Text>

        <Text
          style={{
            fontSize: 12,
            fontFamily: "Manrope",
            fontWeight: 700,
            paddingLeft: "5px",
            marginTop: "20px",
            // paddingBottom: "8px",
          }}
        >
          {/* Uitvoerder: */}
          Uitvoerder:
        </Text>

        <Text
          style={{
            fontSize: 12,
            fontFamily: "Manrope",
            fontWeight: 700,
            marginTop: "20px",
            paddingLeft: "5px",
            // paddingBottom: "8px",
          }}
        >
          {props?.data?.formData[0]?.formresponse[0]?.username}
        </Text>

        <View
          style={{
            // marginTop: 0,
            marginTop: "-15px",
            flexDirection: "row",
            justifyContent: "space-between",
            // alignItems: "center",
          }}
        >
          <View>
            <Text
              style={{
                // marginTop: 10,
                fontSize: 12,
                fontFamily: "Manrope",
                fontWeight: 700,
                paddingLeft: "5px",
                // paddingBottom: "8px",
                opacity: 0,
              }}
            >
              {/* Executant Signature: */}
              Handtekening van de uitvoerende macht
            </Text>

            {props?.data?.document
              ?.filter((x) => x.isClientSignature === 2)
              .map((item, index) => (
                <Image
                  key={index}
                  src={item.url}
                  style={{
                    width: "100%",
                    height: "60px",
                    objectFit: "cover",
                  }}
                />
              ))}
          </View>

          <View>
            <Text
              style={{
                fontSize: 12,
                fontFamily: "Manrope",
                fontWeight: 700,
                paddingLeft: "5px",
                // paddingBottom: "8px",
              }}
            >
              {/* Client Signature: */}
              Handtekening van de klant
            </Text>

            {props?.data?.document
              ?.filter((x) => x.isClientSignature === 1)
              .map((item, index) => (
                <Image
                  key={index}
                  src={item.url}
                  style={{
                    width: "100%",
                    height: "60px",
                    objectFit: "cover",
                  }}
                />
              ))}
          </View>
        </View>

        {/* FOOTER */}
        {/* <View style={styles.footer} fixed>
          <Text style={styles.footerLeft}>ASC1</Text>
          <Text style={styles.footerCenter}>ASC2</Text>
          <Text
            style={styles.footerRight}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View> */}

        {/* Second Row (Duplicate Row) */}
        <View style={styles.footer2} fixed>
          {/* <Text style={styles.footerLeft2}>ASC3</Text> */}
          {/* <Text style={styles.footerCenter2}>ASC4</Text> */}
          {/* <Text
            style={styles.footerRight2}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          /> */}

          {/* <Image
            style={styles.image3}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/mainlogo.png"
            }
          /> */}

          <Image
            style={styles.image4}
            src={
              "https://s3.spire-solutions-1.res.trans-ix.whitesky.cloud/spiresolutions-dev/logo3.png"
            }
          />
        </View>
      </Page>
    </Document>
  );
};

const ReactPDF = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { taskId } = useParams();

  console.log("asc certificate props", props);

  const fetchFormCertificateRes = useSelector(
    (state) => state.user.fetchFormCertificateRes,
  );

  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );

  const formSubmittedRes = useSelector((state) => state.user.formResponse);

  const [pdfData, setPdfData] = useState();

  useEffect(() => {
    dispatch(FetchFormCertificate(taskId));
  }, [formSubmittedRes]);

  useEffect(() => {
    if (fetchFormCertificateRes.status === true) {
      setPdfData(fetchFormCertificateRes.data[0]);
    }
  }, [fetchFormCertificateRes]);

  useEffect(() => {
    if (
      props.runFunctionFromParent === true &&
      fetchFormCertificateRes.data[0]?.formData.length > 0
    ) {
      downloadPDF();
    }
    // props.setRunFunctionFromParent(false);
  }, [props.runFunctionFromParent, fetchFormCertificateRes]);

  const downloadPDF = async () => {
    try {
      const blob = await pdf(<MyDocument data={pdfData} />).toBlob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "certificate.pdf";
      a.click();

      URL.revokeObjectURL(url);

      const file = new File([blob], "certificate.pdf", {
        type: "application/pdf",
      });
      dispatch(filesInsertDocToS3([file]));
    } catch (err) {
      console.error("PDF download error:", err);
    }
  };

  useEffect(() => {
    if (filesInsertDocToS3Res[0]?.status === true) {
      // let payload = filesInsertDocToS3Res.map((item) => ({
      //   documentname: item.documentname,
      //   link: item.link,
      // }));

      // dispatch(AdddocumenttoTask(taskId, payload));

      const uploadedFile = filesInsertDocToS3Res[0]?.data;
      if (uploadedFile) {
        const payload = [
          {
            documentname: uploadedFile.documentname,
            link: uploadedFile.link,
          },
        ];

        // dispatch(AdddocumenttoTask(taskId, payload));

        axios
          // .post(`${API_URL}/api/Task/AdddocumenttoTask`, {
          .post(process.env.REACT_APP_ATTACH_CETIFICATE_API_URL, {
            taskId: taskId,
            token: localStorage.getItem("token"),
            documents: payload,
          })
          .then((res) => {
            console.log("Document added successfully:", res.data);
          })
          .catch((err) => {
            console.error("Error while adding document:", err);
          });
      }
    }
  }, [filesInsertDocToS3Res]);

  return (
    <div>
      <div className="d-non-e">
        <h5>PDF Preview</h5>
        <PDFViewer
          style={{ width: "100%", height: "700px", border: "1px solid black" }}
        >
          <MyDocument data={pdfData} />
        </PDFViewer>
      </div>

      <h5>Download PDF</h5>

      <PDFDownloadLink
        document={<MyDocument data={pdfData} />}
        fileName="certificate22.pdf"
      >
        {/* {({ loading }) =>
          loading ? "Loading document..." : <img src={pdf_icon} alt="" />
        } */}

        {({ loading }) => {
          props.setPdfLoading && props.setPdfLoading(loading);
          return loading ? (
            "Loading document..."
          ) : (
            <img src={pdf_icon} alt="" />
          );
        }}
      </PDFDownloadLink>
    </div>
  );
};

export default ReactPDF;
